import {
  InputLabel,
  MenuItem,
  Select,
  FormControl,
  FormHelperText,
  TextField,
} from "@mui/material";
import React from "react";
import { Field } from "formik";

export const FieldName = () => (
  <Field name="name">
    {({
      field: { name, value, onChange, onBlur },
      meta: { touched, error },
    }) => (
      <TextField
        name={name}
        label="Name"
        value={value}
        error={Boolean(touched && error)}
        fullWidth
        helperText={touched && error}
        onBlur={onBlur}
        onChange={onChange}
      />
    )}
  </Field>
);

export const FieldRole = ({ options }) => (
  <Field name="role">
    {({
      field: { name, value, onChange, onBlur },
      meta: { touched, error },
    }) => (
      <FormControl fullWidth>
        <InputLabel id="role-label">Role</InputLabel>
        <Select
          labelId="role-label"
          id="role"
          name={name}
          label="Role"
          value={value}
          error={Boolean(touched && error)}
          fullWidth
          onBlur={onBlur}
          onChange={onChange}
        >
          {options.map(({ value, display_name }) => (
            <MenuItem value={value} key={value}>
              {display_name}
            </MenuItem>
          ))}
        </Select>
        {touched && error && (
          <FormHelperText>{touched && error}</FormHelperText>
        )}
      </FormControl>
    )}
  </Field>
);

export const FieldEmail = () => (
  <Field name="email">
    {({
      field: { name, value, onChange, onBlur },
      meta: { touched, error },
    }) => (
      <TextField
        name={name}
        label="Email"
        value={value}
        error={Boolean(touched && error)}
        fullWidth
        helperText={touched && error}
        onBlur={onBlur}
        onChange={onChange}
      />
    )}
  </Field>
);

export const FieldStatus = ({ options }) => (
  <Field name="status">
    {({
      field: { name, value, onChange, onBlur },
      meta: { touched, error },
    }) => (
      <FormControl fullWidth>
        <InputLabel id="status-label">Status</InputLabel>
        <Select
          labelId="status-label"
          id="status"
          name={name}
          label="Status"
          value={value}
          error={Boolean(touched && error)}
          fullWidth
          onBlur={onBlur}
          onChange={onChange}
        >
          {options.map(({ value, display_name }) => (
            <MenuItem value={value} key={value}>
              {display_name}
            </MenuItem>
          ))}
        </Select>
        {touched && error && (
          <FormHelperText>{touched && error}</FormHelperText>
        )}
      </FormControl>
    )}
  </Field>
);
